import Menu from './Compartido/Menu.jsx';
import TextoPoliticas from './Politicas/TextoPoliticas.jsx';
import Footer from './Compartido/Footer.jsx';

const Politicas = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextoPoliticas
                politicas={props.politicas}
                config={props.config}
                ruta={props.ruta}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Politicas;
